// src/app/core/guards/libbs-auth.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';

const API_TOKEN_KEY = 'token_backend';

function decode(jwt: string): any | null {
  try {
    const token = jwt.replace(/^Bearer\s+/i, '');
    const parts = token.split('.'); if (parts.length < 2) return null;
    const b64url = parts[1];
    const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/').padEnd(b64url.length + (4 - (b64url.length % 4)) % 4, '=');
    return JSON.parse(atob(b64));
  } catch { return null; }
}

function isExpired(jwt: string): boolean {
  const payload = decode(jwt);
  const exp = Number(payload?.exp);
  if (!Number.isFinite(exp)) return true;
  const now = Math.floor(Date.now() / 1000);
  return exp <= now;
}

function hasRole(payload: any): boolean {
  const r = payload?.role ?? payload?.roles;
  if (Array.isArray(r)) return r.length > 0;
  if (typeof r === 'string') return r.trim().length > 0;
  return false;
}

export const libbsAuthGuard: CanMatchFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const token = (typeof window !== 'undefined') ? localStorage.getItem(API_TOKEN_KEY) : null;

  // Sem token ou expirado → login
  if (!token || isExpired(token)) {
    try { localStorage.removeItem(API_TOKEN_KEY); localStorage.removeItem('token_backend_expiration'); } catch {}
    return router.createUrlTree(['/login'], { queryParams: { error: 'expired' } });
  }

  // Usuário sem acesso (sem role no JWT) → login com aviso
  const payload = decode(token);
  if (!hasRole(payload)) {
    try { localStorage.removeItem(API_TOKEN_KEY); localStorage.removeItem('token_backend_expiration'); } catch {}
    return router.createUrlTree(['/login'], { queryParams: { error: 'noaccess' } });
  }

  // OK
  return true;
};
